import React from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { ButtonSelectionStyled } from '@core/Components/Buttons/Buttons.styles'
import { PriceChangeDisplay } from '../PriceChangeDisplay'

export interface WinPlaceSelection {
  isVisible: boolean
  isDisabled: boolean
  isFavourite: boolean
  isSelected: boolean
  selectionName?: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  priceWin: string
  pricePlace: string
  starterNumber: number
  tidAttribute?: string
  favouritePosition?: 'left' | 'right'
  buttonStyleOverride?: React.CSSProperties
  centerContent?: boolean
  arrowLocation?: 'IN' | 'OUT'
  title?: string
}

export const WinPlaceSelection = React.forwardRef<HTMLButtonElement, WinPlaceSelection>(
  (
    {
      isVisible,
      isDisabled,
      isFavourite,
      isSelected,
      selectionName,
      onClick,
      priceWin,
      pricePlace,
      starterNumber,
      buttonStyleOverride,
      tidAttribute = '',
      favouritePosition = 'right',
      centerContent = false,
      arrowLocation = 'OUT',
      title = undefined,
    },
    ref
  ) => {
    if (!isVisible) {
      return null
    }

    const extra: Record<string, string> = {}
    if (selectionName) extra['data-tid-selection'] = selectionName

    return (
      <WinPlaceSelectionButtonStyled
        isSelected={isSelected}
        ref={ref}
        isDisabled={isDisabled}
        disabled={isDisabled}
        onClick={onClick}
        style={buttonStyleOverride}
        {...{ [tidAttribute]: starterNumber }}
        {...extra}
      >
        {title && (
          <WinPlaceSelectionButtonTitleStyled isContentCentered={centerContent}>
            <div>{title}</div>
          </WinPlaceSelectionButtonTitleStyled>
        )}

        <PriceChangeDisplay
          priceWin={priceWin}
          pricePlace={pricePlace}
          isSelected={isSelected}
          isContentCentred={centerContent}
          arrowLocation={arrowLocation}
        />

        {isFavourite && (
          <WinPlaceSelectionFavouriteStyled favouritePosition={favouritePosition}>
            <Icon name='SolidStar01' color={hexColors.orange} size='1.5rem' />
          </WinPlaceSelectionFavouriteStyled>
        )}
      </WinPlaceSelectionButtonStyled>
    )
  }
)
WinPlaceSelection.displayName = 'WinPlaceSelection'

// ======
// Styles
// ======

const WinPlaceSelectionButtonStyled = styled(ButtonSelectionStyled)({
  width: '5rem',
  minWidth: '5rem',
  height: '5rem',
})

const WinPlaceSelectionButtonTitleStyled = styled.div<{ isContentCentered: boolean }>(
  {
    marginLeft: '0.3rem',
    marginRight: '0.3rem',
    marginTop: '0.3rem',
    marginBottom: '0.4rem',
    fontWeight: 'normal',
  },
  ({ isContentCentered: isContentCentered = false }) => ({
    textAlign: isContentCentered ? 'center' : 'right',
  })
)

const WinPlaceSelectionFavouriteStyled = styled.span<Pick<WinPlaceSelection, 'favouritePosition'>>(
  {
    position: 'absolute',
    top: 0,
  },
  ({ favouritePosition = 'left' }) => ({
    [favouritePosition]: 0,
    transform: `translate(${favouritePosition === 'left' ? '-' : ''}40%,-40%)`,
  })
)
